var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-clock"},[_vm._v("\n  "+_vm._s(_vm.$moment(_vm.sharedTime).format(_vm.format))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }